<router-outlet></router-outlet>
<p-confirmdialog [style]="{ width: '30vw' }">
  <ng-template #rejecticon>
    @if (confirmation()?.rejectIcon; as icon) {
      <i [class]="icon"></i>
    }
  </ng-template>
  <ng-template #accepticon>
    @if (confirmation()?.acceptIcon; as icon) {
      <i [class]="icon"></i>
    }
  </ng-template>
</p-confirmdialog>
<p-toast position="bottom-right"></p-toast>
<p-toast key="revision-error-toast" position="bottom-right">
  <ng-template let-message #message>
    <div class="m-0 grid grid-cols-12 gap-4 p-0">
      <div class="col-span-12 m-0 mt-2 p-0">
        <span class="flex items-center justify-between pb-2">
          <h4 class="m-0 p-0 text-xl">
            <fa-icon [icon]="faTimes" size="lg" class="mr-2"></fa-icon>
            {{ message.summary }}
            <i>
              <button
                type="button"
                class="border-0 bg-transparent p-0 italic"
                (click)="reload()"
                [style]="{ 'text-decoration': 'underline', color: 'black', cursor: 'pointer' }"
              >
                {{ 'reportTasks.reload' | translate }}
                <fa-icon [icon]="faArrowsRotate" class="mr-2"></fa-icon>
              </button>
            </i>
          </h4>
        </span>
        <p>{{ message.detail }}</p>
      </div>
    </div>
  </ng-template>
</p-toast>
<p-toast position="bottom-right" [key]="ERROR_KEY" [baseZIndex]="5000">
  <ng-template let-message #message>
    <div class="w-full">
      <header class="flex items-start justify-between gap-2 pb-2">
        <div class="font-semibold text-red-800">
          {{ message.summary }}
        </div>

        <button pButton type="button" variant="text" rounded severity="danger" (click)="closeErrorMessages()" iconOnly>
          <fa-icon [icon]="faXmark" size="lg"></fa-icon>
        </button>
      </header>

      @if (message.data?.httpError) {
        <div class="space-y-2 rounded-sm border border-gray-200 bg-gray-50 p-4 text-xs">
          @let errorCount = message.data.httpError?.errors?.length || 0;

          @if (errorCount <= 0) {
            <div class="flex items-center justify-between pb-1">
              <span class="font-medium text-gray-700">HTTP {{ message.data.httpError.status }}</span>
              <span class="rounded-sm bg-gray-200 px-2 py-1 text-xs text-gray-600">
                {{ message.data.httpError.error || 'Error' }}
              </span>
            </div>

            @if (message.data.httpError.path) {
              <div class="pb-1 text-gray-600">
                <span class="font-medium">Path:</span>
                {{ message.data.httpError.path }}
              </div>
            }

            @if (message.data.httpError.message) {
              <div class="pb-1 text-gray-700">
                {{ message.data.httpError.message | translate }}
              </div>
            }
          } @else {
            <div class="border-gray-300">
              <div class="mb-1 font-medium text-gray-700">{{ 'messages.errors.validationErrors' | translate }}:</div>

              <div
                [ngStyle]="{
                  'overflow-y': 'auto',
                  'max-height': '10.5rem',
                  'min-height':
                    errorCount === 1 ? '3.5rem' : errorCount === 2 ? '7rem' : errorCount > 2 ? '10.5rem' : null,
                }"
              >
                @for (error of message.data.httpError.errors; track $index; let i = $index) {
                  <div
                    class="rounded-sm border border-red-300 bg-white p-2"
                    [style.margin-top]="i > 0 ? '0.25rem' : null"
                  >
                    <div class="text-xs font-medium text-red-700">
                      @if (error.field) {
                        {{ error.field }}
                      } @else if (error.entity) {
                        {{ error.entity }}
                      } @else if (error.objectName) {
                        {{ error.objectName }}
                      } @else {
                        N/A
                      }
                    </div>
                    <div class="text-xs text-gray-600">
                      @if (error.message) {
                        {{ error.message }}
                      } @else if (error.defaultMessage) {
                        {{ error.defaultMessage }}
                      } @else {
                        N/A
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }

          @if (message.data.httpError.timestamp) {
            <div class="mt-2 border-t border-gray-300 pt-2 text-xs text-gray-500">
              {{ message.data.httpError.timestamp | date: 'long' }}
            </div>
          }
        </div>
      }
    </div>
  </ng-template>
</p-toast>

<p-toast
  key="task-running"
  position="bottom-right"
  [baseZIndex]="1200"
  [autoZIndex]="false"
  [style]="{ 'z-index': 1200 }"
>
  <ng-template let-message #message>
    <div class="m-0 grid grid-cols-12 gap-4 p-0">
      <div class="col-span-12 m-0 mt-2 p-0">
        <span class="flex items-center justify-start pb-2">
          <h4 class="m-0 p-0 text-xl">
            <fa-icon [icon]="faCircleNotch" animation="spin" size="lg" class="mr-2"></fa-icon>
            {{ message.summary }}
          </h4>
        </span>
        <p>{{ message.detail }}</p>
      </div>
    </div>
  </ng-template>
</p-toast>
<p-toast
  key="task-complete"
  position="bottom-right"
  [baseZIndex]="1201"
  [autoZIndex]="false"
  [style]="{ 'z-index': 1201 }"
>
  <ng-template let-message #message>
    <div class="m-0 grid grid-cols-12 gap-4 p-0">
      <div class="col-span-12 m-0 mt-2 p-0">
        <span class="flex items-center justify-between pb-2">
          <h4 class="m-0 p-0 text-xl">
            <fa-icon [icon]="faCheck" size="lg" class="mr-2"></fa-icon>
            {{ message.summary }}
            <i>
              <a
                tabindex="0"
                (click)="goToTask()"
                (keydown.enter)="goToTask()"
                [style]="{ 'text-decoration': 'underline', color: 'black', cursor: 'pointer' }"
              >
                {{ 'reportTasks.seeReport' | translate }}
                <fa-icon [icon]="faArrowRight" class="mr-2"></fa-icon>
              </a>
            </i>
          </h4>
        </span>
        <p>{{ message.detail }}</p>
      </div>
    </div>
  </ng-template>
</p-toast>
